import store from './../store/index'
export default{
  mine:'个人中心',
  home:'首页',
  server:'服务大厅',
  selectlogin:'登录绑定',
  createCard:'新建就诊卡',
  createChildCard:'新建儿童就诊卡',
  bindCard:'成人绑卡',
  bindChildCard:'儿童绑卡',
  bindSuccess:'绑卡成功',
  createSuccess:'建卡成功',
  introduction:'医院简介',
  minePaint:"我的就诊卡",
  minePaintDetail:'详细信息',
  register:'挂号',
  docList:'医生信息',
  docListTime:'医生排班',
  question:'问卷调查',
  detailList:'挂号列表',
  details:'挂号详情',
  success:'挂号成功',
  payList:'缴费列表',
  payDetails:'缴费详情',
  paySuccess:'缴费成功',
  registerList:'挂号记录',
  registerDetail:'挂号记录详情',
  familyDoctor:'家庭医生',
  familyDoctorPerson:'个人基本信息表',
  familyDoctorHealth:'个人基本信息表',
  familyDoctorLive:'个人基本信息表',
  contracted:'家庭医生（团队）签约服务协议书',
  confirmMsg:'预约及确认信息',
  signingRecord:'签约医生记录',
  ordinaryPeople:'一般人服务包',
  children:'儿童服务包',
  pregnantWoman:'孕妇服务包',
  diabetes:'糖尿病服务包',
  hypertension:'高血压服务包',
  aged:'老年人服务包',
  elcsign:'电子签名录入',
  explain: '协议详情',
  reportList:'报告列表',
  paidDetail:'已缴费详情',
  cheackUpDetail:'检查报告详情',
  cheackOutDetail:'检验报告详情',
  heathlyCodeIndex:'电子健康码列表',
  heathlyCodeSignQr:'电子健康码申领',
  apptRegister: '报到列表',
  cheackPay: '报到缴费',
  cheackSucces: '报到成功',
  socPay:"医保支付",
  socPayList:       "移动医保缴费记录",
	onlineInsurancePay:    "医保支付",
	onlineInsuranceStatus: "医保支付状态确认",
	authFail:              "医保授权失败",
  authorization:'授权同意书'
}
